import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Funnel } from "@phosphor-icons/react";
import { getProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const categories = [
  { id: "all", label: "All Hardware" },
  { id: "motorcycle", label: "Motorcycle" },
  { id: "car", label: "Car" },
  { id: "bicycle", label: "Bicycle" },
  { id: "home", label: "Home & Shop" },
  { id: "tracker", label: "GPS Tracker" },
];

export default function ProductsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCat = searchParams.get("cat") || "all";
  const [category, setCategory] = useState(initialCat);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getProducts(category)
      .then(setProducts)
      .finally(() => setLoading(false));
    const params = new URLSearchParams();
    if (category !== "all") params.set("cat", category);
    setSearchParams(params, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  return (
    <div data-testid="products-page" className="bg-[#0a0a0a] text-white min-h-screen">
      <div className="border-b border-white/10 grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 relative">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FFC107] mb-4">// Catalog</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight leading-[0.95]">
            The Arsenal
          </h1>
          <p className="mt-6 text-lg text-zinc-400 max-w-2xl">
            Hardware tested in the field. Filter by your vehicle and pick the right level of protection.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <div className="flex items-center gap-3 mb-10 flex-wrap">
          <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-zinc-500">
            <Funnel size={16} weight="bold" /> Filter
          </span>
          {categories.map((c) => (
            <button
              key={c.id}
              data-testid={`filter-${c.id}`}
              onClick={() => setCategory(c.id)}
              className={`h-10 px-5 text-xs uppercase tracking-[0.18em] font-bold transition-all ${
                category === c.id
                  ? "bg-[#FFC107] text-black"
                  : "border border-white/20 text-white hover:border-[#FFC107] hover:text-[#FFC107]"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-[#141414] border border-white/10 animate-pulse" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div data-testid="empty-state" className="border border-white/10 p-12 text-center text-zinc-400">
            No products in this category yet. Check back soon.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
